var map = {
	"./Author": "./src/Components/Admin/Form/Attributes/Author.js",
	"./Author.js": "./src/Components/Admin/Form/Attributes/Author.js",
	"./Evacuation": "./src/Components/Admin/Form/Attributes/Evacuation.js",
	"./Evacuation.js": "./src/Components/Admin/Form/Attributes/Evacuation.js",
	"./Handicap": "./src/Components/Admin/Form/Attributes/Handicap.js",
	"./Handicap.js": "./src/Components/Admin/Form/Attributes/Handicap.js",
	"./Height": "./src/Components/Admin/Form/Attributes/Height.js",
	"./Height.js": "./src/Components/Admin/Form/Attributes/Height.js",
	"./Interest": "./src/Components/Admin/Form/Attributes/Interest.js",
	"./Interest.js": "./src/Components/Admin/Form/Attributes/Interest.js",
	"./Origintype": "./src/Components/Admin/Form/Attributes/Origintype.js",
	"./Origintype.js": "./src/Components/Admin/Form/Attributes/Origintype.js",
	"./Photopass": "./src/Components/Admin/Form/Attributes/Photopass.js",
	"./Photopass.js": "./src/Components/Admin/Form/Attributes/Photopass.js",
	"./Pmr": "./src/Components/Admin/Form/Attributes/Pmr.js",
	"./Pmr.js": "./src/Components/Admin/Form/Attributes/Pmr.js",
	"./Premieraccess": "./src/Components/Admin/Form/Attributes/Premieraccess.js",
	"./Premieraccess.js": "./src/Components/Admin/Form/Attributes/Premieraccess.js",
	"./Public": "./src/Components/Admin/Form/Attributes/Public.js",
	"./Public.js": "./src/Components/Admin/Form/Attributes/Public.js",
	"./Sensory": "./src/Components/Admin/Form/Attributes/Sensory.js",
	"./Sensory.js": "./src/Components/Admin/Form/Attributes/Sensory.js",
	"./Serie": "./src/Components/Admin/Form/Attributes/Serie.js",
	"./Serie.js": "./src/Components/Admin/Form/Attributes/Serie.js",
	"./Singlerider": "./src/Components/Admin/Form/Attributes/Singlerider.js",
	"./Singlerider.js": "./src/Components/Admin/Form/Attributes/Singlerider.js",
	"./Sort": "./src/Components/Admin/Form/Attributes/Sort.js",
	"./Sort.js": "./src/Components/Admin/Form/Attributes/Sort.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/Components/Admin/Form/Attributes sync recursive ^\\.\\/.*$";